module.exports = __webpack_public_path__ + "img/sk.bc11e388.svg";